
export default {
  list: [],
  isUnique: true
}



// WEBPACK FOOTER //
// ./src/features/admin/chats/store/state.js